import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../../../shared/api/axios-instance';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { AppResponseMinimalDto } from '../../../dtos/app-response-minimal.dto';
import { AppResponseMinimalModel } from '../../../models/app-response-minimal.model';
import { mapExceptedAppsDtoToExceptedAppsModel } from '../../../utils/excepted-apps-mapping.util';

export const getExceptedApps: AsyncThunk<
  AppResponseMinimalModel[],
  void,
  Record<string, unknown>
> = createAsyncThunk<AppResponseMinimalModel[], void>(
  'get-excepted-apps',
  async (): Promise<AppResponseMinimalModel[]> => {
    const { data }: AxiosResponse<AppResponseMinimalDto[]> =
      await axiosInstance.get(Endpoints.GET_APP_EXCEPTIONS);

    return data.map(mapExceptedAppsDtoToExceptedAppsModel);
  }
);
